import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ActionStatus } from './ActionStatus';


export default function Action({status, title, detail}) {

  return <li className={`Action is-${ActionStatus[status].name} list-group-item py-1 px-3`}>
    <div className="Action-inner">
    <FontAwesomeIcon className={`Action-icon text-${ActionStatus[status].color} ${ActionStatus[status].additionalClasses}`} icon={ActionStatus[status].icon} />
      <span className="Action-title">{title}</span>
    </div>
    <div className={`Action-details ${detail != undefined ? '' : 'd-none'}`}>{detail}</div>
  </li>
}